import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import apiRoute from '../../../common/constants/apiRoute';
import { AuthService } from '../../../features/auth/services/auth.service';
import { filter, switchMap, take } from 'rxjs';
import identityRoute from '../../../common/constants/identityRoute';
import claimRoute from '../../../common/constants/claimRoute';
import { environment } from '../../../../environments/environment'
import cmsRoute from '../../../common/constants/cmsRoute';
import { PlatformsService } from '../services/platforms.service';
import { LocalStorageService } from '../services/localStorage.service';


@Injectable()
export class RequestInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService,private platformService:PlatformsService,
 private localStorageService:LocalStorageService

  ) {}



  intercept(req: HttpRequest<any>, next: HttpHandler) {
    if (req.method === 'JSONP') return next.handle(req);

    let baseUrl: string;

    if (req.url.includes('ePayment')) {
      baseUrl = environment.paymentRoute;
    } else if (req.url.includes('connect/token')) {
      baseUrl = identityRoute;
    } else if (
      req.url.includes('cristalclaims') ||
      req.url.includes('vehicleclaims') ||
       /claims\/[^/]+\/rate/i.test(req.url) ||
      /claims\/[^/]+\/file/i.test(req.url) ||
      req.url.includes('claims/rate') ||
      req.url.includes('PreClaim') ||
      req.url.includes('locations')
    ) {
      baseUrl = claimRoute;
    } else if (req.url.includes('banner')) {
      baseUrl = cmsRoute;
    } else {
      baseUrl = apiRoute;
    }
let useTokenBridge = this.platformService.isIOs() || this.platformService.isEmbeddedApp();

// localStorage.setItem('storedAuth','H4EMxZw/FhZlnDuzpzACZqv0ua3KaRMQjApkHirHphE=');
//localStorage.setItem('storedAuth','7WOYAMGHiY9XW4pxBOPipAcjwuX4ZIzz9exaLYWvm6w=');
//localStorage.setItem('user','henry.lora@lacolonial.com.do');
    // 👉 (1) SI VIENE DEL WEBVIEW NATIVO → USAR HASH EN VEZ DE JWT


    if (useTokenBridge) {
 const storedAuth = this.localStorageService.getSessionToken();
      const hash = storedAuth?.hash;

    const bridgedReq = req.clone({
        setHeaders: {
          'X-Client-Hash': hash ?? ''
        },
        url: baseUrl + req.url,
      });

      return next.handle(bridgedReq);
    }

    // 👉 (2) FLUJO NORMAL DE BROWSER → USAR JWT
    let obs = this.auth.authToken$;

    return obs.pipe(
      filter((token) => !!token),
      take(1),
      switchMap((token) => {
        if (token) {
          const authToken = 'Bearer ' + token;
          const authReq = req.clone({
            setHeaders: { Authorization: authToken },
            url: baseUrl + req.url,
          });
          return next.handle(authReq);
        } else {
          return next.handle(req);
        }
      })
    );
  }
}
